import { emitDistinctChangesOnlyDefaultValue } from '@angular/compiler';
import { Component,ChangeDetectionStrategy, ElementRef, Input, ViewChild,ChangeDetectorRef,Output,EventEmitter, Inject, OnInit, Renderer2, HostListener} from '@angular/core';
import { AdsService } from '@app/ads/services/ads.service';
import { ADS_BANNER } from '@app/ads/tokens';
import { Helper } from '@app/core/helper';

@Component({
    selector: 'div.banner.in6c',
    templateUrl: '../templates/b2.component.html',
    host: {
        '[style.--banner-color]': 'ban.p.bg'
    },
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class B2Component {
    viewed:boolean = false;
    timeout: any

    constructor(
        private srv: AdsService,
        private cdr: ChangeDetectorRef,
        @Inject(ADS_BANNER)
        public ban: any,
        private el:ElementRef,
        private ren:Renderer2,
    ) {}

    clk(e:any): void {
        this.srv.click(this.ban, this.ban.location);
    }

    @HostListener('window:resize')
    rsz(): void {
        this.chkVue();
    }

    @HostListener('window:scroll')
    scr(event: any): void {
        this.chkVue();
    }

    chkVue(): void {
        let isVue;
        clearTimeout(this.timeout)
        if (this.ban.location === 'in_body') {
            isVue = !!this.el.nativeElement.classList.contains('visible');
        } else {
            isVue = Helper.isElementInViewport(this.el.nativeElement);
        }
        if (!this.viewed && isVue) {
            this.timeout = setTimeout(() => {
                this.viewed = true;
                this.srv.view(this.ban, this.ban.location);
            },1000)
        }
    }
}
